module.exports = __webpack_public_path__ + "static/media/Wagner Alcove Units (3).aca1bf59.jpg";